import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "hiddenField"]

  declare containerTarget: HTMLElement
  declare hiddenFieldTarget: HTMLInputElement

  connect() {
    this.loadExistingMappings()
  }

  addRow() {
    const row = this.createRow("", "")
    this.containerTarget.appendChild(row)
    this.syncToHidden()
  }

  removeRow(event: Event) {
    const button = event.currentTarget as HTMLElement
    const row = button.closest(".saml-attribute-editor__row")
    if (row) {
      row.remove()
      this.syncToHidden()
    }
  }

  fieldChanged() {
    this.syncToHidden()
  }

  private loadExistingMappings() {
    const value = this.hiddenFieldTarget.value
    if (!value || value === "{}" || value === "null") return

    try {
      const mappings = JSON.parse(value) as Record<string, string>
      for (const [key, val] of Object.entries(mappings)) {
        const row = this.createRow(key, String(val))
        this.containerTarget.appendChild(row)
      }
    } catch {
      // Invalid JSON — ignore
    }
  }

  private createRow(key: string, value: string): HTMLElement {
    const row = document.createElement("div")
    row.className = "saml-attribute-editor__row"

    const select = document.createElement("select")
    select.className = "saml-attribute-editor__key"
    select.dataset.action = "change->organization--sso--saml--provider-form-component--saml-attribute-editor#fieldChanged"

    const fieldOptions = [
      { value: "", label: "Select field..." },
      { value: "email", label: "Email" },
      { value: "subject_id", label: "Subject ID" },
      { value: "display_name", label: "Display Name" },
      { value: "given_name", label: "Given Name" },
      { value: "family_name", label: "Family Name" },
      { value: "groups", label: "Groups" },
    ]

    fieldOptions.forEach(opt => {
      const option = document.createElement("option")
      option.value = opt.value
      option.textContent = opt.label
      if (opt.value === key) option.selected = true
      select.appendChild(option)
    })

    const input = document.createElement("input")
    input.type = "text"
    input.className = "saml-attribute-editor__value saml-provider-form-component__input"
    input.placeholder = "SAML attribute name (e.g. urn:oid:0.9.2342...)"
    input.value = value
    input.dataset.action = "input->organization--sso--saml--provider-form-component--saml-attribute-editor#fieldChanged"

    const button = document.createElement("button")
    button.type = "button"
    button.className = "btn btn--red-stroke btn--small"
    button.dataset.action = "organization--sso--saml--provider-form-component--saml-attribute-editor#removeRow"
    button.textContent = "Remove"

    row.appendChild(select)
    row.appendChild(input)
    row.appendChild(button)

    return row
  }

  private syncToHidden() {
    const rows = this.containerTarget.querySelectorAll(".saml-attribute-editor__row")
    const mappings: Record<string, string> = {}

    rows.forEach(row => {
      const key = (row.querySelector(".saml-attribute-editor__key") as HTMLSelectElement)?.value
      const value = (row.querySelector(".saml-attribute-editor__value") as HTMLInputElement)?.value
      if (key && value) {
        mappings[key] = value
      }
    })

    this.hiddenFieldTarget.value = JSON.stringify(mappings)
  }
}
